import { apiRequest } from "@/network/apiClient";
import { ArrowLeft, BellIcon, Plus, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import AddNewLead from "@/components/lead-inventory/add_new_lead.jsx";
import AddOpportunityModal from "./referral/AddOpportunityModal";

const pageSubHeader = ({ title, role, showBackButton }) => {
  const navigate = useNavigate();

  const [showNewLeadModal, setShowNewLeadModal] = useState(false);
  const [showNewOppModal, setShowNewOppModal] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const dropdownRef = useRef(null);
  const handleNewLead = () => {
    setShowNewLeadModal(true);
  };
  const handleNewOpp = () => {
    setShowNewOppModal(true);
  };

  const handleSignOut = () => {
    try {
      localStorage.removeItem("userId");
      localStorage.removeItem("role");
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("pkce_verifier");
      localStorage.removeItem("leadId");
      localStorage.removeItem("email");
      window.location.href = `${import.meta.env.VITE_BASE_URL}/logout`;
    } catch (error) {
      console.error("Error during logout", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };

    if (showNotifications) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications]);

  return (
    <>
      <div className="flex flex-row items-center justify-between sticky top-0 bg-white border-t border-gray-200 shadow z-50 px-8 py-4">
        <div className="flex flex-row items-center text-lg text-gray-700 font-bold">
          {showBackButton && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "34px",
                height: "34px",
                borderRadius: "50%",
                borderWidth: 1,
                borderColor: "#000000ff",
                backgroundColor: "#ffffffff",
                color: "#000000ff",
              }}
              className="cursor-pointer mr-4"
              onClick={() => navigate(-1)}
            >
              <ArrowLeft className="w-5 h-5 text-gray-600" />
            </div>
          )}
          {title}
        </div>

        <div className="flex flex-row items-center space-x-4">
          {role === "Hunter" || role === "Admin" ? (
            <button
              className="bg-[#FEFAD8] text-black font-bold px-4 py-2 rounded-md"
              onClick={handleNewLead}
            >
              <div className="flex flex-row">
                <Plus />
                New Lead
              </div>
            </button>
          ) : null}
          {role === "Farmer" || role === "Admin" ? (
            <button
              className="bg-[#FEFAD8] text-black font-bold px-4 py-2 rounded-md"
              onClick={handleNewOpp}
            >
              <div className="flex flex-row">
                <Plus />
                New Opportunity
              </div>
            </button>
          ) : null}
          <div className="relative" ref={dropdownRef}>
            <div
              className="cursor-pointer flex justify-center items-center w-[34px] h-[34px] rounded-full border-2 border-gray-200 bg-white"
              onClick={() => setShowNotifications(!showNotifications)}
            >
              <BellIcon
                className="w-4 h-4 text-gray-600"
                strokeWidth={2.5}
                style={{ fill: "#c5c5c5ff" }}
              />
              {/* Notification bubble */}
              {/* <span
                className="absolute top-0 right-0 inline-flex items-center justify-center 
                           w-4 h-4 text-[10px] font-bold text-white bg-red-600 
                           rounded-full transform translate-x-1 -translate-y-1"
              >
                3
              </span> */}
            </div>
            {/* Notification dropdown */}
            {showNotifications && (
              <div className="absolute right-0 mt-2 w-64 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                <div className="p-3 text-sm text-gray-700 font-semibold border-b">
                  Notifications
                </div>
                <ul className="divide-y divide-gray-100">
                  <li className="p-3 hover:bg-gray-50 cursor-pointer">
                    No new notifications for now
                  </li>
                </ul>
              </div>
            )}
          </div>
          <div className="relative group" onClick={handleSignOut}>
            <LogOut
              className="w-6 h-6 hover:text-yellow-300 transition-colors cursor-pointer"
              strokeWidth={2.5}
              style={{ fill: "#c5c5c5ff" }}
            />
            <span className="absolute left-1/2 -translate-x-1/2 mt-2 px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
              Logout
            </span>
          </div>
        </div>
      </div>
      <AddNewLead
        isOpen={showNewLeadModal}
        onClose={() => setShowNewLeadModal(false)}
      />
      <AddOpportunityModal
        isOpen={showNewOppModal}
        onClose={() => setShowNewOppModal(false)}
      />
    </>
  );
};

export default pageSubHeader;
